import getReactMajorVersion from './_util/getReactMajorVersionCanDelMe';
import warning from './_util/warning';
export { default as Affix } from './affix';
export { default as Alert } from './alert';
export { default as Anchor } from './anchor';
export { default as App } from './app';
export { default as AutoComplete } from './auto-complete';
export { default as Avatar } from './avatar';
export { default as BackTop } from './back-top';
export { default as Badge } from './badge';
export { default as BorderBeam } from './border-beam';
export { default as Breadcrumb } from './breadcrumb';
export { default as Button } from './button';
export { default as Calendar } from './calendar';
export { default as Card } from './card';
export { default as Carousel } from './carousel';
export { default as Cascader } from './cascader';
export { default as Checkbox } from './checkbox';
export { default as Col } from './col';
export { default as Collapse } from './collapse';
export { default as ColorPicker } from './color-picker';
export { default as ConfigProvider } from './config-provider';
export { default as DatePicker } from './date-picker';
export { default as Descriptions } from './descriptions';
export { default as Divider } from './divider';
export { default as Drawer } from './drawer';
export { default as Dropdown } from './dropdown';
export { default as Empty } from './empty';
export { default as Flex } from './flex';
export { default as FloatButton } from './float-button';
export { default as Form } from './form';
export { default as Grid } from './grid';
export { default as Image } from './image';
export { default as Input } from './input';
export { default as InputNumber } from './input-number';
export { default as Layout } from './layout';
export { default as List } from './list';
export { default as Listy } from './listy';
export { default as Masonry } from './masonry';
export { default as Mentions } from './mentions';
export { default as Menu } from './menu';
export { default as message } from './message';
export { default as Modal } from './modal';
export { default as notification } from './notification';
export { default as Pagination } from './pagination';
export { default as Popconfirm } from './popconfirm';
export { default as Popover } from './popover';
export { default as Progress } from './progress';
export { default as QRCode } from './qr-code';
export { default as Radio } from './radio';
export { default as Rate } from './rate';
export { default as Result } from './result';
export { default as Row } from './row';
export { default as Segmented } from './segmented';
export { default as Select } from './select';
export { default as Skeleton } from './skeleton';
export { default as Slider } from './slider';
export { default as Space } from './space';
export { default as Spin } from './spin';
export { default as Splitter } from './splitter';
export { default as Statistic } from './statistic';
export { default as Steps } from './steps';
export { default as Switch } from './switch';
export { default as Table } from './table';
export { default as Tabs } from './tabs';
export { default as Tag } from './tag';
export { default as theme } from './theme';
export { default as TimePicker } from './time-picker';
export { default as Timeline } from './timeline';
export { default as Tooltip } from './tooltip';
export { default as Tour } from './tour';
export { default as Transfer } from './transfer';
export { default as Tree } from './tree';
export { default as TreeSelect } from './tree-select';
export { default as Typography } from './typography';
export { default as Upload } from './upload';
export { default as version } from './version';
export { default as Watermark } from './watermark';
export const unstableSetRender = () => {
    warning(false, 'compatible', "antd v6 support React 19 already, it's no need to call the compatible function or just remove `@ant-design/v5-patch-for-react-19`");
};
// Warning if React is less than 18 (not include 18)
if (process.env.NODE_ENV !== 'production') {
    const majorVersion = getReactMajorVersion();
    warning(majorVersion >= 18, 'version', `antd v6 no longer supports React versions below 18. Please upgrade to React 18 or higher.`);
}
